import React from "react";

export const LISTINGS_TABS = [
  {
    label: "Manage Listings",
    path: "/rc/listings",
    iconSrc: "/assets/icons/tab-manage-listings.png",
  },
  {
    label: "Lookbooks",
    path: "/listings/lookbooks",
    iconSrc: "/assets/icons/tab-lookbooks.png",
  },
  {
    label: "Listing Network",
    path: "/rc/listings/network",
    // Source/sell outside your network (Feature 22) — Future Release, so the
    // tab is hidden entirely rather than shown locked.
    feature: "outside_network_search",
    iconSrc: "/assets/icons/tab-listing-network.png",
  },
];

export const ListingsTabIcon = ({ src, alt = "" }) => (
  <img src={src} alt={alt} className="rc-listings-tab-icon" aria-hidden={!alt} />
);
